import script from "./FacePurchase.vue?vue&type=script&setup=true&lang=js"
export * from "./FacePurchase.vue?vue&type=script&setup=true&lang=js"

import "./FacePurchase.vue?vue&type=style&index=0&id=63425b77&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63425b77"]])

export default __exports__